import { Pipe, PipeTransform } from '@angular/core';
import {UserRoles} from '../../enums/general-enums';

@Pipe({
  name: 'checkActiveRole',
  standalone: true
})
export class CheckActiveRolePipe implements PipeTransform {

  transform(subscriptions: Array<any>): string {
    if (subscriptions === null || subscriptions === undefined) {
      return UserRoles.freemium;
    }

    const activePlans = subscriptions.filter((subscription: any) => subscription.stripe_status === 'active');
    const highestId = Math.max(...activePlans.map(obj => obj.id));
    const activeSubscription = activePlans.find(obj => obj.id === highestId);

    if (activeSubscription) {
      if (['tlalister', 'tlalister-mobile'].includes(activeSubscription.type)) {
        return UserRoles.aLister;
      } else if (['tlexpert', 'tlexpert-mobile'].includes(activeSubscription.type)) {
        return UserRoles.expert;
      } else if (['tlpartner', 'tlpartner-mobile'].includes(activeSubscription.type)) {
        return UserRoles.company;
      } else {
        return UserRoles.freemium;
      }
    }

    return UserRoles.freemium;
  }

}
